import React from 'react'
import { useTheme } from '@opallabs/hooks'
import { kuiperClassNames } from '@opallabs/kuiper'
import { BudgetDetails } from './BudgetDetails'
import { LabelDetails, Label } from './LabelDetails'
import { PostOptionDetails, PostOption } from './PostOptionDetails'
import * as styles from './styles'

type ContentDetailsProps = {
  budget: string
  labels: Array<Label>
  postOptions: Array<PostOption>
}

const ContentDetails: React.FC<ContentDetailsProps> = ({
  budget,
  labels = [],
  postOptions = [],
}) => {
  const theme = useTheme()
  return (
    <div
      css={styles.wrapper(theme)}
      className={kuiperClassNames('content-details')}
    >
      {!budget && !labels.length && !postOptions.length ? (
        <span>No content details</span>
      ) : (
        <React.Fragment>
          <BudgetDetails budget={budget} />
          <PostOptionDetails postOptions={postOptions} />
          {labels.length ? <LabelDetails labels={labels} /> : null}
        </React.Fragment>
      )}
    </div>
  )
}

export default ContentDetails
